module.exports = __webpack_public_path__ + "static/media/DeviceListCSV.d41d8cd9.csv";